var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAndroid)?_c('div',{staticClass:"back-button",on:{"click":_vm.onClick}},[_c('van-icon',{attrs:{"size":"25px","name":"arrow-left"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }